<template>
  <div>
    <img
      :class="pictureClass"
      :src="
        picture
          ? `${
              !big ? picture.thumbnail_path : picture.public_path
            }?api_token=${token}`
          : ''
      "
      @load="handleLoad"
    />
    <h5>{{ title }}</h5>
  </div>
</template>

<script>
import { types as t } from "../../../../../store/actions/pictures";
import {
  handleImageDimensions,
  ImageDimensions
} from "../../../../../util/func";

export default {
  name: "BoundApiPicture",
  props: {
    pictureId: {
      required: true
    },
    big: {
      type: Boolean,
      default: false
    },
    ratio: {
      type: Number
    },
    title: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      picture: null,
      dim: ImageDimensions({})
    };
  },
  methods: {
    async getPicture() {
      if (typeof this.pictureId !== "undefined" && this.pictureId !== null) {
        this.picture = await this.$store.dispatch(
          t.GET_PICTURE,
          this.pictureId
        );
      }
    },
    handleLoad(e) {
      this.dim = handleImageDimensions(e.target);
    }
  },
  computed: {
    token() {
      return this.$store.state.user.token;
    },
    pictureClass() {
      if (this.dim.aspectRatio > this.ratio) return `BoundApiPicture__tooLarge`;
      if (this.dim.aspectRatio < this.ratio) return `BoundApiPicture__tooHigh`;
      return "";
    }
  },
  mounted() {
    this.getPicture();
  },
  watch: {
    picture(val) {
      if (val) {
        this.$emit("load", val);
      }
    },
    pictureId() {
      this.$nextTick(() => {
        this.getPicture();
      });
    }
  }
};
</script>

<style lang="scss">
img[lazy="loaded"] {
  opacity: 0;
  animation-name: fadein;
  animation-duration: 0.5s;
  animation-iteration-count: 1;
  animation-fill-mode: forwards;
  animation-direction: normal;
  animation-timing-function: ease-out;

  @keyframes fadein {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
}

.BoundApiPicture__tooLarge {
  width: 100%;
  height: auto;
}

.BoundApiPicture__tooHigh {
  height: 100%;
  width: auto;
}
</style>
